<template>
  <div class="home">
    <div v-if="facility=='app'" class="app">
      <Mbanner/>
      <Mnav/>
      <Mrecommend/>
      <Mactivity/>
      <Mvideo/>
    </div>
    <div v-else >
      <Banner @rolling="rolling" />
      <Shinetop id="page"/>
      <ActivityLive/>
      <Supply/>
      <div class="productSponsorBg">
        <Product/>
        <Sponsor/>
      </div>
    </div>
  </div>
</template>

<script>
import Mbanner from "./app/banner";
import Mnav from "./app/nav";
import Mrecommend from "./app/recommend";
import Mactivity from "./app/activity";
import Mvideo from "./app/video";
import Banner from "./pc/banner";
import Shinetop from "./pc/shinetop";
import Supply from "./pc/supply";
import ActivityLive from "./pc/activityLive";
import Product from "./pc/product";
import Sponsor from "./pc/sponsor";

export default {
  components:{
    Mbanner,
    Mnav,
    Mrecommend,
    Mactivity,
    Mvideo,
    Banner,
    Shinetop,
    Supply,
    ActivityLive,
    Product,
    Sponsor,
  },
  data () {
    return {
      facility:"",
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  mounted () {
    
  },
  methods:{
    homejump(id){
      document.querySelector(id).scrollIntoView(true);
      //querySelector可以获取dom元素，括号内为css属性选择器；
    },
    rolling(){
      // 获取点击的按钮对应页面的id
      var PageId = document.querySelector('#page')
      window.scrollTo({
      'top': PageId.offsetTop-60,
      'behavior': 'smooth'
      })
      }
  }

}
</script>

<style>
  .icon{
    vertical-align: middle;
    color: rgb(71, 70, 70);
  }
  .home{
    height: 100%;
  }
  /* app start */
  .home .app h4{
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 600;
    line-height: 30px;
    margin: 10px 0;
  }
  .home .app h4>span{
    font-weight: 100;
    font-size: 12px;
  }
  .app img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  /* app end */
  .pcHeader{
    height: 50px;/*no*/
  }
  .pcContent{
    background-color: white;
    height: calc(100vh - 50px);/*no*/
    overflow: hidden;
  }
  .pcContent>div{
    height: 100%;
  }
  .swiper-wrapper:first-child{
    background-color: #000;
    position: relative;
  }
  .productSponsorBg{
    background: #ffffff url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/title&bg/homeGMBg.jpg') no-repeat top center;
    background-size: 100% 100%;
  }
  
</style>